<template>
  <div>
    <Card>
      <h4 slot="header">Itineraries</h4>
      <Itineraries/>
    </Card>
    <Card>
      <h4 slot="header">Parking</h4>
      <Parking/>
    </Card>
    <Card>
      <h4 slot="header">Non-Resident Gate Passes</h4>
      <GatePasses/>
    </Card>
  </div>
</template>

<script>
// import components
import Itineraries from '@/components/reservations/Itineraries'
import GatePasses from '@/components/reservations/GatePasses'
import Parking from '@/components/reservations/Parking'

export default {
  name: 'Reservations',
  components: {
    Itineraries,
    Parking,
    GatePasses
  }
}
</script>
